import type { Location } from 'react-router';

const FORCE_LOGIN = 'force_login';
const REDIRECT = 'redir';
const DEFAULT_REDIRECT = '/';

export function hasForceLogin(location: Location): boolean {
  return new URLSearchParams(location.search).has(FORCE_LOGIN);
}

export function extractSafeRedirectPath(location: Location): string {
  const redirectionPath = new URLSearchParams(location.search).get(REDIRECT);

  if (!redirectionPath || redirectionPath.includes('\\')) {
    return DEFAULT_REDIRECT;
  }

  try {
    // normalize against current origin and ensure it stays same-origin
    const url = new URL(redirectionPath, window.location.origin);

    if (url.origin !== window.location.origin) {
      return DEFAULT_REDIRECT;
    }

    return `${url.pathname}${url.search}${url.hash}`;
  } catch {
    return DEFAULT_REDIRECT;
  }
}

export function buildPostLoginUrl(location: Location, token: string | null): string {
  const redirectPath = extractSafeRedirectPath(location);
  const url = new URL(redirectPath, window.location.origin);
  const loginSearchParams = new URLSearchParams(location.search);

  loginSearchParams.forEach((value, key) => {
    if (key === REDIRECT || key === FORCE_LOGIN) {
      return;
    }

    url.searchParams.append(key, value);
  });

  if (token) {
    url.searchParams.set('token', token);
  }

  return `${url.pathname}${url.search}${url.hash || location.hash}`;
}
